import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback, useContext } from 'react'

import { resetModifiedDataByField, useGetFormDataField } from 'cng-common/features/form'
import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'

import { BasicInfoSaveContext } from '../../../../BasicInfoSaveContext'
import { LOCATIONS_SEPARATOR, PARTNER_BASIC_INFO_FORM_KEY } from '../../../../configs'
import { TRANSLATION_KEYS } from '../../translations'

import styles from './LocationsEditorDialogFooter.module.scss'

interface ILocationsEditorFooterProps {
  isSaving: boolean
  setIsSaving: (isSaving: boolean) => void
  locations: string[]
  fieldName: string
  onClose: () => void
}

export const LocationsEditorDialogFooter = ({
  locations,
  isSaving,
  setIsSaving,
  fieldName,
  onClose,
}: ILocationsEditorFooterProps) => {
  const dispatch = useAppDispatch()
  const saveBasicInfo = useContext(BasicInfoSaveContext)
  const [, changeValue] = useGetFormDataField<string>(PARTNER_BASIC_INFO_FORM_KEY, fieldName)

  const cancelChanges = useCallback(() => {
    dispatch(
      resetModifiedDataByField({
        field: fieldName,
        formKey: PARTNER_BASIC_INFO_FORM_KEY,
      })
    )
    onClose()
  }, [dispatch, onClose, fieldName])

  const saveLocations = useCallback(async () => {
    const value = locations.join(LOCATIONS_SEPARATOR)
    changeValue(value)
    setIsSaving(true)
    try {
      await saveBasicInfo?.({ [fieldName]: value })
      onClose()
    } catch {
      // Keep the editor open so the user can retry.
    } finally {
      setIsSaving(false)
    }
  }, [changeValue, onClose, locations, saveBasicInfo, fieldName, setIsSaving])

  return (
    <div className={styles.actionButtons}>
      <Button disabled={isSaving} className={styles.cancel} onClick={cancelChanges}>
        <Translation text={TRANSLATION_KEYS.cancelButton} span />
      </Button>
      <Button disabled={isSaving} color="success" onClick={saveLocations}>
        <Translation text={TRANSLATION_KEYS.saveButton} span />
      </Button>
    </div>
  )
}
